"use strict";

exports.__esModule = true;
exports["default"] = exports.MainImage = exports.ImageWrapper = exports.ImageContainer = exports.HtmlImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ImageWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "image__ImageWrapper",
  componentId: "sc-1jgry1o-0"
})(["border-radius:8px;overflow:hidden;font-size:0;"]);
exports.ImageWrapper = ImageWrapper;
var ImageContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "image__ImageContainer",
  componentId: "sc-1jgry1o-1"
})(["display:inline-block;margin:0;"]);
exports.ImageContainer = ImageContainer;
var MainImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "image__MainImage",
  componentId: "sc-1jgry1o-2"
})(["max-width:100%;height:auto;"]);
exports.MainImage = MainImage;
var titleFont = {
  color: "text-title",
  fontSize: 4,
  fontWeight: 1,
  lineHeight: 2,
  mb: 1,
  textAlign: "left"
};
var descriptionFont = {
  alignItems: "left",
  color: "text-helper",
  fontSize: 2,
  fontWeight: 1,
  lineHeight: 3
};
var propTypes = {
  /** alt text of the image */
  alt: _propTypes.string,

  /** Container class name */
  className: _propTypes.string,

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** description text */
  description: _propTypes.string,

  /** Determines the height of the image */
  height: _propTypes.number,

  /** image src url */
  image: _propTypes.string,

  /** position of container */
  position: _propTypes.string,

  /** title text for image */
  title: _propTypes.string,

  /** Determines the width of the image */
  width: _propTypes.number
};
var defaultProps = {
  height: null,
  width: null
};

var HtmlImage = function HtmlImage(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      dataTestId = _ref["data-test-id"],
      description = _ref.description,
      height = _ref.height,
      image = _ref.image,
      position = _ref.position,
      title = _ref.title,
      width = _ref.width;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    className: className,
    "data-test-id": dataTestId,
    mx: "auto",
    my: 4,
    width: [1, 3 / 4, 1]
  }, /*#__PURE__*/_react["default"].createElement(ImageContainer, {
    tag: "figure"
  }, /*#__PURE__*/_react["default"].createElement(ImageWrapper, null, /*#__PURE__*/_react["default"].createElement(MainImage, {
    alt: alt,
    height: height,
    src: image,
    width: width
  })), title || description ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    pb: 2,
    position: position,
    pt: 1,
    tag: "figcaption"
  }, title ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, titleFont, title) : null, description ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, descriptionFont, description) : null) : null));
};

exports.HtmlImage = HtmlImage;
HtmlImage.defaultProps = defaultProps;
HtmlImage.propTypes = propTypes;
HtmlImage.displayName = "Modules.HtmlImage";
var _default = HtmlImage;
exports["default"] = _default;